import { Estrutura } from "../modelo/Estrutura";
import fetch from "../../api/AxiosAdapter";
import ConfiguracaoAm from "../ConfiguracaoAm";

class EstruturaApi {

    async recuperarTodos(): Promise<Estrutura[]> {
        const result = await fetch<Estrutura[]>(ConfiguracaoAm.urlEstrutura);
        return result.data;
    }

    async filtrar(estrutura: Estrutura): Promise<Estrutura[]> {
        const result = await fetch<Estrutura[]>(ConfiguracaoAm.urlEstrutura + 'filtrar', {
            method: 'POST',
            body: estrutura
        });
        return result.data;
    }

    async criarEstruturasPadrao() {
        await fetch(ConfiguracaoAm.urlEstrutura + '/criar-padrao', {
            method: 'POST'
        });
    }

    async atualizar(estrutura: Estrutura) {
        const result = await fetch<Estrutura[]>(ConfiguracaoAm.urlEstrutura, {
            method: 'PUT',
            body: estrutura
        });
        return result.data;
    }

    async salvar(estrutura: Estrutura) {
        const result = await fetch<Estrutura[]>(ConfiguracaoAm.urlEstrutura, {
            method: 'POST',
            body: estrutura
        });
        return result.data;

    }

    async excluir(estrutura: Estrutura) {
        return await fetch<Estrutura[]>(ConfiguracaoAm.urlEstrutura + estrutura.id, {
            method: 'DELETE'
        });
    }
}

export default new EstruturaApi();